import React from 'react';
import { Box, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { Link as RouterLink } from 'react-router-dom';

// Markdown components configuration
const markdownComponents = {
  p: ({ node, ...props }) => (
    <Typography component="span" variant="body1" sx={{ display: 'block', mb: 1 }}>
      {props.children}
    </Typography>
  ),
  a: ({ node, href, ...props }) => {
    const isInternal = href?.startsWith('/');
    if (isInternal) {
      return (
        <RouterLink
          to={href}
          style={{ color: '#1abc9c', textDecoration: 'underline' }}
        >
          {props.children}
        </RouterLink>
      );
    }
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#1abc9c', textDecoration: 'underline' }}
        {...props}
      />
    );
  },
  li: ({ node, ...props }) => (
    <Typography component="li" variant="body1" sx={{ ml: 2 }}>
      {props.children}
    </Typography>
  ),
  ul: ({ node, ...props }) => (
    <Box component="ul" sx={{ m: 0, pl: 2 }}>
      {props.children}
    </Box>
  ),
  ol: ({ node, ...props }) => (
    <Box component="ol" sx={{ m: 0, pl: 2 }}>
      {props.children}
    </Box>
  ),
  strong: ({ node, ...props }) => (
    <Box component="strong" sx={{ fontWeight: 'bold' }}>
      {props.children}
    </Box>
  ),
};

const BottomImage = ({ title, text, image, url }) => (
  <Box id={url || ''} sx={{ textAlign: 'center', mb: 6, maxWidth: '1200px', mx: 'auto', px: 2 }}>
    <Typography variant="h4">{title}</Typography>
    <Box sx={{ mb: 4, '& > *:last-child': { mb: 0 } }}>
      <ReactMarkdown components={markdownComponents}>
        {text}
      </ReactMarkdown>
    </Box>
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <img src={image} alt={title} style={{ width: '100%', borderRadius: '4px' }} />
    </Box>
  </Box>
);

export default BottomImage;